// @unocss-include
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from '@a-type/ui';
import { animated, useSpring } from '@react-spring/web';
import { useIsRouteTransitioning } from '@verdant-web/react-router';
import { useCallback, useEffect } from 'react';
export function TopLoader({ className }) {
    const show = useIsRouteTransitioning(500);
    const [style, spring] = useSpring(() => ({
        width: '0%',
    }));
    const run = useCallback(() => {
        let timeout;
        function step(previous) {
            spring.start({
                width: `${previous}%`,
            });
            const nextStep = Math.min(95 - previous, Math.min((95 - previous) / 2, Math.random() * 20));
            timeout = setTimeout(step, 500 + Math.random() * 1000, previous + nextStep);
        }
        step(0);
        return () => {
            if (timeout)
                clearTimeout(timeout);
            spring.start({
                width: '100%',
            });
        };
    }, [show, spring]);
    useEffect(() => {
        if (show) {
            return run();
        }
    }, [show, run]);
    return (_jsx("div", { className: clsx('fixed top-0 left-0 w-full h-4px pointer-events-none op-0 z-100000', '[&[data-state=visible]]:(opacity-100 transition-opacity)', 'md:(h-2px)', 'motion-reduce:hidden', className), "data-state": show ? 'visible' : 'hidden', children: _jsx(animated.div, Object.assign({}, {
            className: 'absolute top-0 left-0 h-full bg-accent',
            style,
        })) }));
}
//# sourceMappingURL=TopLoader.js.map